import { COMPANIES_PATH } from 'commons/constants/routes'
import { CompanyWebPage } from 'commons/types/DTO/bank'
import { Link } from 'ui/components/Link'
import { TableActions, TableColumn } from 'ui/components/Table'

export const columns = (onDeleteCompany: (company: any) => void): TableColumn<CompanyWebPage>[] => [
  {
    title: 'Account Name',
    render: ({ id, accountName }) => (
      <Link to="/relationships/$id" params={{ id: id.toString() }}>
        {accountName}
      </Link>
    ),
    sortable: true,
    key: 'accountName',
    align: 'left'
  },
  {
    align: 'left',
    title: 'DBA',
    key: 'dba'
  },
  {
    align: 'left',
    title: 'Holding Company',
    sortable: true,
    key: 'holdingCompany',
    render: ({ holdingID, holdingCompany }) =>
      holdingCompany && holdingID ? (
        <Link to="/relationships/$id" params={{ id: holdingID.toString() }}>
          {holdingCompany}
        </Link>
      ) : (
        ''
      )
  },
  {
    align: 'center',
    title: 'Business Type',
    key: 'businessType'
  },
  {
    align: 'center',
    title: 'Entity Type',
    key: 'entityType'
  },
  {
    align: 'center',
    title: 'Customer Status',
    key: 'customerStatus'
  },
  {
    title: 'Actions',
    align: 'center',
    width: '50px',
    render: (item) => (
      <TableActions
        items={[
          {
            type: 'edit',
            url: `${COMPANIES_PATH}/edit/${item.id}`
          },
          {
            type: 'delete',
            onClick: () => onDeleteCompany({ id: item.id, name: item.accountName })
          }
        ]}
      />
    )
  }
]
